import React from "react";
import logo from "../../assets/images/iAugment-logo-color.png";
import useChangePassword from "../../customHooks/ChangePassword/useChangePassword";
import NotFound from "../NotFound/NotFound";

const ChangePassword = () => {
  const {
    password,
    confirmPassword,
    passwordError,
    confirmPasswordError,
    showPassword,
    setShowConfirmPassword,
    setShowPassword,
    showConfirmPassword,
    handlePasswordChange,
    handleConfirmPasswordChange,
    handleSubmit,
    submitLoader,
    isSuccess,
    auth,
  } = useChangePassword();

  return (
    <>
      {auth ? (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
          <header className="fixed top-0 left-0 w-full bg-gradient-to-r from-blue-600 to-purple-600 py-4 shadow-md flex items-center justify-center">
            <img src={logo} alt="VTO SaaS Logo" className="h-10 mr-2" />
          </header>
          {isSuccess ? (
            <div className="mt-20 w-full max-w-md bg-white shadow-lg rounded-lg p-6 text-center">
              <div className="flex justify-center">
                <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center">
                  ✅
                </div>
              </div>
              <h2 className="text-2xl font-semibold text-gray-700 mt-4">
                Password Changed Successfully!
              </h2>
              <p className="text-gray-600 mt-2">
                You can now log in with your new password.
              </p>
            </div>
          ) : (
            <div className="mt-20 w-full max-w-md bg-white shadow-lg rounded-lg p-6">
              <h2 className="text-2xl font-semibold text-gray-700 text-center mb-4">
                Change Password
              </h2>

              <form className="space-y-4">
                <div>
                  <label className="block text-gray-600 font-medium mb-1">
                    New Password
                  </label>
                  <div className="relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      value={password}
                      onChange={handlePasswordChange}
                      className={`w-full px-4 py-2 border rounded-lg focus:ring-2 ${
                        passwordError
                          ? "border-red-500 focus:ring-red-500"
                          : "border-gray-300 focus:ring-blue-500"
                      }`}
                      placeholder="Enter new password"
                      required
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute inset-y-0 right-3 flex items-center text-gray-500 hover:text-gray-700"
                    >
                      {showPassword ? "👁" : "👁‍🗨"}
                    </button>
                  </div>
                  {passwordError && (
                    <p className="text-red-500 text-sm mt-1">{passwordError}</p>
                  )}
                </div>

                <div>
                  <label className="block text-gray-600 font-medium mb-1">
                    Confirm Password
                  </label>
                  <div className="relative">
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      value={confirmPassword}
                      onChange={handleConfirmPasswordChange}
                      className={`w-full px-4 py-2 border rounded-lg focus:ring-2 ${
                        confirmPasswordError
                          ? "border-red-500 focus:ring-red-500"
                          : "border-gray-300 focus:ring-blue-500"
                      }`}
                      placeholder="Confirm your password"
                      required
                    />
                    <button
                      type="button"
                      onClick={() =>
                        setShowConfirmPassword(!showConfirmPassword)
                      }
                      className="absolute inset-y-0 right-3 flex items-center text-gray-500 hover:text-gray-700"
                    >
                      {showConfirmPassword ? "👁" : "👁‍🗨"}
                    </button>
                  </div>
                  {confirmPasswordError && (
                    <p className="text-red-500 text-sm mt-1">
                      {confirmPasswordError}
                    </p>
                  )}
                </div>

                <button
                  type="submit"
                  className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition shadow-md disabled:bg-gray-400 disabled:cursor-not-allowed"
                  disabled={
                    passwordError || confirmPasswordError || submitLoader
                  }
                  onClick={handleSubmit}
                >
                  {submitLoader ? "Changing..." : "Change Password"}
                </button>
              </form>
            </div>
          )}
        </div>
      ) : (
        <NotFound />
      )}
    </>
  );
};

export default ChangePassword;
